<template>
  <v-card class="elevation-12" loading="true">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Сброс пароля</v-toolbar-title>
    </v-toolbar>
    <v-form @submit.prevent="restore()">
      <v-card-text>
        <v-text-field
          label="Почта"
          name="login"
          prepend-icon="mdi-account"
          type="text"
          required
          v-model="email"
        ></v-text-field>

        <v-text-field
          v-if="showCode"
          id="password"
          label="Новый пароль"
          name="password"
          prepend-icon="mdi-lock"
          type="password"
          required
          v-model="password"
        ></v-text-field>

        <v-text-field
          v-if="showCode"
          id="passwordAgain"
          label="Новый пароль ещё раз"
          name="passwordAgain"
          prepend-icon="mdi-lock"
          type="password"
          required
          v-model="passwordAgain"
        ></v-text-field>

        <v-text-field
          v-if="showCode"
          label="Код"
          name="code"
          type="text"
          required
          v-model="code"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" type="submit" v-if="showCode">
          Сбросить пароль
          <v-progress-circular
            v-if="loading"
            class="ml-1"
            indeterminate
            size="18"
          ></v-progress-circular>
        </v-btn>
        <get-code v-else :email="email" @code-sent="codeSent" />
        <v-spacer></v-spacer>
        <v-btn @click="$emit('login-form')">Войти</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import store from "../store";
import axios from "axios";
import api from "../api";
import GetCode from "./GetCode";

export default {
  name: "restore-form",
  components: {
    GetCode
  },
  data() {
    return {
      email: "",
      code: "",
      id: 0,
      loading: false,
      showCode: false,
      password: "",
      passwordAgain: ""
    };
  },
  methods: {
    codeSent: function({ id }) {
      this.showCode = true;
      this.id = id;
    },
    restore: function() {
      this.loading = true;
      if (this.password === this.passwordAgain) {
        axios
          .post(api.restore, {
            id: this.id,
            code: this.code,
            password: this.password
          })
          .then(() => {
            store.snackbar = true;
            store.snackbarSuccess = true;
            store.snackbarMessage = "Пароль изменён";
            this.$emit("login-form");
          })
          .catch(err => {
            store.snackbar = true;
            store.snackbarSuccess = false;
            store.snackbarMessage = err.message;
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        store.snackbar = true;
        store.snackbarSuccess = false;
        store.snackbarMessage = "Пароли не совпадают";
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
